// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"20a4a07d","126":"4c138af4","507":"abfc4512","787":"bc27c3f1","913":"abfc12df"}[chunkId] + ".chunk.js";
};